<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div :style="`height: ${detailHeight}px; overflow-y: auto`">
        <div class="div_common_search" style="margin-bottom: 10px; width: 99%">
          <t-divider>{{ $t("resource.NUMBER.NUMBER_INFORMATION") }}</t-divider>
          <div class="search" style="margin-bottom: 10px">
            <t-form
              label-width="160px"
              label-position="right"
              inline
              :model="commonSet"
            >
              <t-form-item :label="$t('resource.NUMBER.COMMISSION_RATE')">
                <t-input
                  v-model="commonSet.commissionRate"
                  maxLength="5"
                  style="width: 220px; height: 35px"
                  class="right"
                  @blur="dataProcess()"
                ></t-input>
              </t-form-item>

              <t-form-item :label="$t('resource.NUMBER.TRANSPORT_COST')">
                <t-input
                  v-model="commonSet.transportCost"
                  maxLength="6"
                  style="width: 220px; height: 35px"
                  class="right"
                  @blur="dataProcess()"
                ></t-input>
              </t-form-item>

              <t-form-item :label="$t('resource.NUMBER.GROSS_MARGIN')">
                <t-input
                  v-model="commonSet.grossMargin"
                  maxLength="5"
                  style="width: 220px; height: 35px"
                  class="right"
                  @blur="dataProcess()"
                ></t-input>
              </t-form-item>
            </t-form>
          </div>
        </div>

        <div class="div_common_search" style="margin-bottom: 10px; width: 99%">
          <t-divider>{{
            $t("resource.ACCEPT_ORDER.ACCEPT_ORDER_TAB")
          }}</t-divider>
          <div class="search" style="margin-bottom: 10px">
            <t-form
              label-width="160px"
              label-position="right"
              inline
              :model="commonSet"
            >
              <t-form-item :label="$t('resource.COMMON_SET.HINT_UPDATE_DAY')">
                <t-input
                  v-model="commonSet.hintUpdateHour"
                  maxLength="4"
                  style="width: 220px; height: 35px"
                  class="right"
                  @blur="dataProcess()"
                ></t-input>
              </t-form-item>
            </t-form>
          </div>
        </div>

         <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
        <!-- 目的港の追加 -->
        <div class="div_common_search" style="padding-bottom: 10px;margin-bottom: 10px; width: 99%;">
          <t-divider>{{
              $t("resource.COMMON_SET.ORDER")
            }}</t-divider>
          <div class="search" style="width: 90%; margin-bottom: 10px;  margin-left: auto; margin-right: auto; ">
            <t-form label-width="100px" style="margin-bottom: 10px;" >
              <t-col :span="24">
                <t-form-item :label=" $t('resource.COMMON_SET.DESTINATION_PORT')" >
                  <t-table
                    ref="destinationList"
                    :data="destinationList"
                    class="table_common"
                    :height="destDetailHeight"
                    header-cell-class-name="bg-default"
                    border
                  >
                    <t-table-column
                      v-for="(column, index) in destPortColumns"
                      :key="index"
                      :type="column.type"
                      :prop="column.prop"
                      :label="column.label"
                      :min-width="column.width"
                      :class-name="column.class"
                      :show-overflow-tooltip="column.overflowTooltip"
                    >
                      <template slot-scope="scope">
                        <t-checkbox
                          v-if="column.prop == 'dpDelFlag'"
                          v-model="scope.row[column.prop]"
                          true-label="1"
                          false-label="0"
                        ></t-checkbox>
                        <span v-else-if="column.prop == 'dpCode'"
                          >{{ scope.row[column.prop] }}
                        </span>
                        <t-input
                          v-else
                          class="editInput"
                          :maxLength="column.maxLength"
                          v-model="scope.row[column.prop]"
                        />
                      </template>
                    </t-table-column>
                  </t-table>
                </t-form-item>
              </t-col>
            </t-form>
          </div>
        </div>
        <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
      </div>

      <div :style="`height: ${bottomHeight}px`">
        <div style="text-align: right">
          <t-button
            round
            type="warning"
            class="dialogButton_confirm_120_40"
            ref="confirmBtn"
            @click="confirmClick()"
          >
            <i class="el-icon-check"></i>
            {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
          >
        </div>
      </div>
    </t-card>
  </div>
</template>

<script>
import { t } from "@/locales";
import { changeCommonSetInfo, getCommonSetInfo } from "@/services/commonSet";
import {
  formatCurrencyToNumber,
  formatStringToCurrency,
  getDialogContentHeightComm,
  numberFormat
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      showFlag: false,
      commonSet: {
        commissionRate: 0,
        transportCost: 0,
        grossMargin: 0,
        hintUpdateHour: 24,
      },

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      destPortColumns: [
        // 目的港コード
        {
          prop: "dpCode",
          label: t("resource.customerInfo.mgrCode"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 目的港名
        {
          prop: "dpName",
          label: t("resource.customerInfo.mgrName"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_center",
          maxLength: 15,
          overflowTooltip: false,
        },

        //削除
        {
          prop: "dpDelFlag",
          label: t("resource.customerInfo.mgDelFlag"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
      ],

      // 目的港リスト
      destinationList: [],
      // 目的港データ
      destinationFormData: [],

      destDetailHeight: DIALOG_LINE_HEIGHT * 5,
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
      //明細情報のheight
      // detailHeight: getDialogContentHeight(window.innerHeight, 0, 0, 0),
      detailHeight: getDialogContentHeightComm(window.innerHeight, 0, 0, 0),
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
    };
  },
  mounted() {
    //画面初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
  // 目的港の追加
  watch: {
    destinationList: {
      handler(newVal) {
        this.updateDestDetailHeight();
      },
      deep: true, // 深度监听，监听内部属性变化
      immediate: true // 立即执行
    }
  },
// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑


  methods: {
    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
      // this.detailHeight = getDialogContentHeight(window.innerHeight, 0, 0, 0);
      this.detailHeight = getDialogContentHeightComm(
        window.innerHeight,
        0,
        0,
        0
      );
      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑
      //合計情報のheight

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      this.updateDestDetailHeight();

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

    },

    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    updateDestDetailHeight() {
      // 最大8行表示、8行を超える場合にのみ高さを増やす
      if (this.destinationList.length > 5) {
        // 一行追加ごとに高さを増す
        const extraRows = this.destinationList.length - 5;
        this.destDetailHeight = DIALOG_LINE_HEIGHT * (5 + extraRows);

        const maxHeight = DIALOG_LINE_HEIGHT * 9;
        if (this.destDetailHeight > maxHeight) {
          this.destDetailHeight = maxHeight;
        }
      } else {
        this.destDetailHeight = DIALOG_LINE_HEIGHT * 5;
      }
    },
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

    // 画面初期化
    init() {
      this.showFlag = true;
      //共通設定情報の取得
      this.infoInit();
    },

    //共通設定情報の初期化
    infoInit() {
      //共通設定情報の取得
      getCommonSetInfo()
        .then((res) => {
          this.showFlag = false;
          //提成率(%)
          this.commonSet.commissionRate = res.commissionRate;
          //運賃(kg)
          this.commonSet.transportCost = res.transportCost;
          //粗利率(%)
          this.commonSet.grossMargin = res.grossMargin;
          //提示更新時間
          this.commonSet.hintUpdateHour = res.hintUpdateHour;
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 目的港の追加
          // 目的港リストの取得
          this.destinationList = res.destinationPortMstInfo;

          let nullRowCnt = 5;
          var dpCodeTemp = 0;

          if (this.destinationList != null && this.destinationList.length > 0) {
            dpCodeTemp =  parseInt(this.destinationList[this.destinationList.length - 1].dpCode);

          }

          for (let i = 1; i <= nullRowCnt; i++) {
            this.destinationList.push({
              //納品先コード
              dpCode:
              (dpCodeTemp + i).toString().padStart(3, "0"),
              //納品先名
              dpName: "",
              //削除区分
              dpDelFlag: "0",
              dpCreateTime:"",
            });
          }
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

          this.dataProcess();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
    },

    //データの処理
    dataProcess() {
      //提成率(%)
      this.commonSet.commissionRate = numberFormat(
        this.commonSet.commissionRate,
        "0.00"
      );
      if (this.commonSet.commissionRate > 99.99) {
        this.commonSet.commissionRate = 99.99;
      } else if (this.commonSet.commissionRate < 0) {
        this.commonSet.commissionRate = 0;
      } else {
        this.commonSet.commissionRate = this.commonSet.commissionRate;
      }

      //運賃(kg)
      this.commonSet.transportCost = formatStringToCurrency(
        formatCurrencyToNumber(this.commonSet.transportCost)
      );

      //粗利率(%)
      this.commonSet.grossMargin = numberFormat(
        this.commonSet.grossMargin,
        "0.00"
      );
      if (this.commonSet.grossMargin > 99.99) {
        this.commonSet.grossMargin = 99.99;
      } else if (this.commonSet.grossMargin < 0) {
        this.commonSet.grossMargin = 0;
      } else {
        this.commonSet.grossMargin = this.commonSet.grossMargin;
      }

      //提示更新時間
      this.commonSet.hintUpdateHour = numberFormat(
        this.commonSet.hintUpdateHour,
        "0"
      );

    },

    //共通設定情報の変更
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 目的港の追加
      if (!this.inputCheck()) {
        return;
      }
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      //変更
      changeCommonSetInfo({
        commissionRate: this.commonSet.commissionRate,
        transportCost: this.commonSet.transportCost,
        grossMargin: this.commonSet.grossMargin,
        hintUpdateHour: this.commonSet.hintUpdateHour,
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        destinationPortMstInfo: this.destinationList,
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.init();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    // 目的港の追加    

    inputCheck() {
        var hasDuplicateDpName = (() => {
        const nonEmptyNames = this.destinationList
          .filter(item => item.dpName && item.dpName.trim() !== '')
          .map(item => item.dpName);

        return nonEmptyNames.length !== new Set(nonEmptyNames).size;
      })();

        if (hasDuplicateDpName) {
          Modal.showWarning("", "重複しない名称で入力してください", {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }


       // 空値チェック
      const hasEmptyName = this.destinationList.some((item, index) => {
        if (item.dpCreateTime !== undefined && item.dpCreateTime !== "" &&
            (item.dpName == "" || item.dpName == undefined)) {
          Modal.showWarning(
            "",
            "コード「" + item.dpCode + "」の名称" + t("message.input.hint"),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return true;
        }
        return false;
      });

      if (hasEmptyName) {
        return false;
      }
      return true;
    }

    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

  },
};
</script>
<style scoped >
/* .text-right {
  text-align: right;
} */
</style>

